var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('router-link',{attrs:{"to":{ name: 'projects' }}},[_c('txt',{attrs:{"phrase":"Projects"}})],1),_c('router-link',{attrs:{"to":{ name: 'info' }}},[_c('txt',{attrs:{"phrase":"Information"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }